import React from 'react'
import back from '../img/BG1.jpg'
import Workinner from './Workinner'


const Workshops = () => {
    return (
        <>
         <div className="workshop">
     
          <div className="workshop__back1"></div>
            <div className="workshop__back2">
                <h1>Workshops</h1>
                <h2>Learn to create</h2>
            </div>
            <div className="workshop__back3"></div>

           
            <Workinner />

           
          </div>
        </>
    )
}

export default Workshops
